"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Billing = void 0;
const core_1 = require("@smash-sdk/core");
const core_2 = require("@smash-sdk/core");
const errors_1 = require("./errors");
__exportStar(require("./errors"), exports);
__exportStar(require("./types/UnsubscribeSubscription/UnsubscribeSubscription"), exports);
__exportStar(require("./types/UpdateInformations/UpdateInformations"), exports);
__exportStar(require("./types/CreateStripeSetupIntent/CreateStripeSetupIntent"), exports);
__exportStar(require("./types/CreateSubscription/CreateSubscription"), exports);
__exportStar(require("./types/ExecutePaypalPayment/ExecutePaypalPayment"), exports);
__exportStar(require("./types/ExecuteStripePayment/ExecuteStripePayment"), exports);
__exportStar(require("./types/GetGroup/GetGroup"), exports);
__exportStar(require("./types/GetInformations/GetInformations"), exports);
__exportStar(require("./types/GetInvoice/GetInvoice"), exports);
__exportStar(require("./types/GetPlan/GetPlan"), exports);
__exportStar(require("./types/GetPlanGroup/GetPlanGroup"), exports);
__exportStar(require("./types/GetStripePaymentMethod/GetStripePaymentMethod"), exports);
__exportStar(require("./types/GetSubscription/GetSubscription"), exports);
__exportStar(require("./types/InitiatePaypalPayment/InitiatePaypalPayment"), exports);
__exportStar(require("./types/InitiateStripePayment/InitiateStripePayment"), exports);
__exportStar(require("./types/ListGroupPlans/ListGroupPlans"), exports);
__exportStar(require("./types/ListInvoices/ListInvoices"), exports);
__exportStar(require("./types/ListSubscriptionLimits/ListSubscriptionLimits"), exports);
const endpoints = {
    "ca-central-1": "https://billing.ca-central-1.fromsmash.co",
    "eu-central-1": "https://billing.eu-central-1.fromsmash.co",
    "eu-west-1": "https://billing.eu-west-1.fromsmash.co",
    "eu-west-2": "https://billing.eu-west-2.fromsmash.co",
    "eu-west-3": "https://billing.eu-west-3.fromsmash.co",
    "us-east-1": "https://billing.us-east-1.fromsmash.co",
    "us-east-2": "https://billing.us-east-2.fromsmash.co",
    "us-west-1": "https://billing.us-west-1.fromsmash.co",
    "us-west-2": "https://billing.us-west-2.fromsmash.co",
};
core_2.config.setHosts("billing", endpoints, false);
class Billing extends core_1.Client {
    constructor(params = {}) {
        super(Object.assign(Object.assign({ service: "billing" }, params), { type: "regional", userAgent: "@smash-sdk/billing@0.0.6-alpha.1" }));
        this.errors = errors_1.errors;
    }
    unsubscribeSubscription(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/subscription/unsubscribe",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    bodyParameters: {
                        reasonType: params["reasonType"],
                        description: params["description"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UnsubscribeSubscriptionError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    updateInformations(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "PUT",
                    path: "/informations",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    bodyParameters: {
                        city: params["city"],
                        state: params["state"],
                        stateCode: params["stateCode"],
                        country: params["country"],
                        zipCode: params["zipCode"],
                        company: params["company"],
                        address: params["address"],
                        lastName: params["lastName"],
                        firstName: params["firstName"],
                        vatNumber: params["vatNumber"],
                        countryCode: params["countryCode"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.UpdateInformationsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createStripeSetupIntent() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/stripe/setupIntent",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateStripeSetupIntentError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    createSubscription(params = {}) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/subscription",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    bodyParameters: {
                        plan: params["plan"],
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.CreateSubscriptionError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    executePaypalPayment(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/paypal/payment/:token/execute",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        token: params["token"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ExecutePaypalPaymentError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    executeStripePayment(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/stripe/payment/:paymentIntentId/execute",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        paymentIntentId: params["paymentIntentId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ExecuteStripePaymentError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getInformations() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/informations",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetInformationsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getInvoice(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/invoice/:invoiceId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        invoiceId: params["invoiceId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetInvoiceError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getPlan(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/plan/:planId",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        planId: params["planId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetPlanError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getPlanGroup(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/plan/:planId/group",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        planId: params["planId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetPlanGroupError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getStripePaymentMethod() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/stripe/paymentMethod",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetStripePaymentMethodError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    getSubscription() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/subscription",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.GetSubscriptionError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    initiatePaypalPayment() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/paypal/payment/initiate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InitiatePaypalPaymentError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    initiateStripePayment() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "POST",
                    path: "/stripe/payment/initiate",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.InitiateStripePaymentError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listGroupPlans(params) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/group/:groupId/plans",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {
                        groupId: params["groupId"],
                    },
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListGroupPlansError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listInvoices() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/invoices",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListInvoicesError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
    listSubscriptionLimits() {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            try {
                const requestParams = {
                    host: this.host,
                    method: "GET",
                    path: "/limits",
                    headers: {
                        Authorization: "Bearer " + this.token,
                    },
                    pathParameters: {},
                    queryParameters: {
                        version: "07-2021",
                    },
                    refreshTokenMethod: this.refreshTokenMethod,
                };
                const request = new core_2.HttpRequest(requestParams);
                const response = yield this.handle(request);
                const parsedResponse = this.parseResponse(response, this.errors.ListSubscriptionLimitsError);
                resolve(parsedResponse);
            }
            catch (error) {
                if (error instanceof Error) {
                    if (error instanceof core_2.SDKError) {
                        reject(error);
                    }
                    else {
                        reject(new core_2.SDKError(error));
                    }
                }
                else {
                    reject(new core_2.SDKError(error));
                }
            }
        }));
    }
}
exports.Billing = Billing;
Billing.errors = errors_1.errors;
